import { cookieUtil } from '@liepin/js-core4c-fe';
import { loadUserInfoAjax } from '../service';

// eslint-disable-next-line import/prefer-default-export
export function loadUserInfoFn(check = true) {
  const userRoles = cookieUtil.get('user_roles');
  const uniqueKey = cookieUtil.get('UniqueKey');
  if (check) {
    if (
      !uniqueKey
      || (uniqueKey && !userRoles)
      || (uniqueKey && userRoles && !userRoles.includes('0'))
    ) { // 没有登录 || 登录了没有用户身份 || 登录了但是不是c用户
      return Promise.resolve({});
    }
  }

  return loadUserInfoAjax();
}